<template>
    <app-panel
        :title="label"
        title-tag="h4"
        tag="article"
        variant="compact"
        :overflow-visible="editable"
        panel-class="min-w-0 shadow-none"
    >
        <input-select
                v-if="editable"
                :id="selectId"
                :value="selectedId"
                class="stage-filter-select"
                :options="options"
                :required="true"
                option-label="name"
                @input="$emit('select', $event)"
            >
                <template #selectedOption="props">
                    <div v-if="props && props.option" class="flex min-w-0 items-center space-x-3">
                        <img
                            :src="optionAvatar(props.option)"
                            :alt="optionDisplayName(props.option)"
                            class="h-6 w-6 flex-shrink-0 rounded-sm object-cover"
                        >
                        <span class="block truncate font-medium">{{ optionDisplayName(props.option) }}</span>
                    </div>
                    <span v-else class="block truncate">Leistungskonto wählen</span>
                </template>
                <template #selectOption="props">
                    <div class="flex min-w-0 items-center space-x-3">
                        <img
                            :src="optionAvatar(props.option)"
                            :alt="optionDisplayName(props.option)"
                            class="h-6 w-6 flex-shrink-0 rounded-sm object-cover"
                        >
                        <div class="min-w-0">
                            <div
                                class="truncate"
                                :class="Number(props.option.id) === Number(selectedId) ? 'font-semibold' : 'font-normal'"
                            >
                                {{ optionDisplayName(props.option) }}
                            </div>
                        </div>
                    </div>
                </template>
                <template #notFound>
                    <div class="font-normal text-gray-500">Keine Leistungskonten verfügbar</div>
                </template>
        </input-select>

        <div v-else-if="party" class="flex min-w-0 items-center">
                <img
                    v-if="party.avatar"
                    :src="party.avatar"
                    :alt="party.display_name || party.account_name || label"
                    class="h-10 w-10 flex-shrink-0 rounded-sm object-cover"
                >
                <div
                    v-else
                    class="flex h-10 w-10 flex-shrink-0 items-center justify-center rounded-sm bg-gray-100 text-sm font-medium text-gray-500"
                    aria-hidden="true"
                >
                    {{ partyInitials }}
                </div>
                <div class="ml-3 min-w-0">
                    <div class="truncate text-sm font-medium text-gray-800">
                        {{ party.display_name || party.account_name }}
                    </div>
                    <div v-if="partyMeta" class="mt-0.5 truncate text-xs text-gray-500">
                        {{ partyMeta }}
                    </div>
                </div>
        </div>

        <div v-else class="text-sm text-gray-500">Kein Leistungskonto hinterlegt</div>
    </app-panel>
</template>

<script>
export default {
    name: 'finance-service-party-card',
    props: {
        label: {type: String, required: true},
        party: {type: Object, default: null},
        editable: {type: Boolean, default: false},
        options: {type: Array, default: () => []},
        selectedId: {type: [Number, String], default: null},
        selectId: {type: String, default: ''},
    },
    emits: ['select'],
    computed: {
        partyMeta() {
            if (!this.party) return '';

            const address = String(this.party.address || '').trim();
            if (address) return address;

            return this.accountMeta(
                this.party.account_name,
                this.party.display_name
            );
        },
        partyInitials() {
            const name = String(this.party?.display_name || this.party?.account_name || '').trim();
            if (!name) return '–';

            return name
                .split(/\s+/)
                .slice(0, 2)
                .map((part) => part.charAt(0).toUpperCase())
                .join('');
        },
    },
    methods: {
        optionDisplayName(option) {
            return String(option?.holder_name || option?.name || 'Leistungskonto');
        },
        optionAvatar(option) {
            return option?.image || option?.avatar || option?.gravatar || '/images/default/icon.png';
        },
        accountMeta(accountName, displayName) {
            const values = [];
            const normalizedAccountName = String(accountName || '').trim();
            const normalizedDisplayName = String(displayName || '').trim();

            if (normalizedAccountName && normalizedAccountName !== normalizedDisplayName) {
                values.push(normalizedAccountName);
            }

            return values.join(' · ');
        },
    },
};
</script>
